import React, { PropsWithChildren } from 'react'
import clsx from 'clsx'
import { Autosave as AutosaveStyles } from '@airbus/elements/elements'
import { createUseStyles } from '../../lib/styling'
import { CommonProps } from '../helperTypes'

type Props = PropsWithChildren<{
  /** Saving status */
  saved?: boolean
  /**
   * Size
   * @default medium
   */
  size?: 'medium' | 'small'
}>

export type AutosaveProps = Props & CommonProps

const useStyles = createUseStyles(AutosaveStyles, 'autosave')

const Autosave = ({ children, className, saved, size = 'medium', ...rest }: AutosaveProps) => {
  const classes = useStyles()
  return (
    <div
      role='status'
      className={clsx(classes.root, className, {
        [classes._progress]: !saved,
        [classes._success]: saved,
        [classes._small]: size === 'small',
      })}
      {...rest}
    >
      {children}
      {!children && (saved ? 'Saved' : 'Saving…')}
    </div>
  )
}

export default Autosave
